// extracted by mini-css-extract-plugin
export default {"notFound":"notFound__higV0t","code":"code__EsLUWu","bee":"bee__ZGa3FP","heading":"heading__Dfsj_m","description":"description__FxEO26","link":"link__BlTcHB"};